var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1.11rem",
    height: "1.11rem",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    alt: "Required Attention Soon Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.1,17.2L11.2,1.6C11,1.2,10.6,1,10.2,1h0c-0.4,0-0.8,0.2-1,0.6L1.3,17.2c-0.2,0.4-0.2,0.8,0,1.2 c0.2,0.4,0.6,0.6,1,0.6h15.8c0.4,0,0.8-0.2,1-0.6C19.2,18.1,19.2,17.6,19.1,17.2z M10.2,16.6c-0.6,0-1.1-0.5-1.1-1.2 c0-0.7,0.5-1.2,1.1-1.2c0.6,0,1.1,0.5,1.1,1.2C11.3,16.1,10.8,16.6,10.2,16.6z M11.3,11.8c0,0.7-0.5,1.2-1.1,1.2 c-0.6,0-1.1-0.5-1.1-1.2V7c0-0.7,0.5-1.2,1.1-1.2c0.6,0,1.1,0.5,1.1,1.2V11.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.5656f336.svg";
export { ForwardRef as ReactComponent };